/**
 * Copied from https://github.com/zeit/next.js/blob/canary/examples/with-portals/components/ClientOnlyPortal.js
 */
import { useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import useHasMounted from '@chegg-wt/core/hooks/useHasMounted'

export default function ClientOnlyPortal({ children, selector = 'body' }) {
  const ref = useRef()
  const mounted = useHasMounted()

  useEffect(() => {
    ref.current = document.querySelector(selector)
  }, [selector])

  return mounted ? createPortal(children, ref.current) : null
}
